import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../helpers/utils";

const IbPaymentScreen = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const startPayment = async () => {
      try {
        const userEmail = searchParams.get("email");
        if (!userEmail) {
          alert("❌ Email is missing in query params.");
          return;
        }
  
        const payload = { email: userEmail, amount: 209 };
        const res = await api.post("/create-ib-premium-order", payload); // ✅ use api not axios
        const order = res.data;
  
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: order.amount,
          currency: order.currency,
          name: "InvestorBook Premium",
          description: "Unlock full investor database",
          order_id: order.id,
          notes: {
            email: userEmail,
            purpose: "investorbook_premium_access",

          },
          handler: async function (response) {
            try {

              alert("✅ Payment successful! Premium unlocked.");
              window.location.href = "https://investorbook.in"; // ✅ redirect
            } catch (verifyErr) {
              console.error("Verification failed:", verifyErr);
              alert("Payment verification failed.");
            }
          },
          prefill: { email: userEmail },
          theme: { color: "#5d0bc1" },
        };
  
        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (err) {
        console.error("Error starting payment:", err);
        alert("Something went wrong, please try again.");
      }
    };
  
    startPayment();
  }, [searchParams]);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.heading}>Pepchat • InvestorBook</h2>
        <p style={styles.text}>Redirecting you to Razorpay...</p>
        <div style={styles.loader}></div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: "#0d0d0d",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Inter, sans-serif",
    color: "#fff",
  },
  card: {
    background: "linear-gradient(145deg, #1a1a1a, #121212)",
    padding: "40px",
    borderRadius: "20px",
    boxShadow: "0 0 20px rgba(93, 11, 193, 0.4)",
    textAlign: "center",
    width: "400px",
    animation: "fadeIn 0.8s ease-in-out",
  },
  heading: {
    fontSize: "22px",
    fontWeight: "bold",
    background: "linear-gradient(90deg, #8d96f5, #5d0bc1)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "15px",
  },
  text: {
    fontSize: "16px",
    color: "#b3b3b3",
    marginBottom: "20px",
  },
  loader: {
    border: "4px solid rgba(255, 255, 255, 0.1)",
    borderLeftColor: "#5d0bc1",
    borderRadius: "50%",
    width: "36px",
    height: "36px",
    margin: "0 auto",
    animation: "spin 1s linear infinite",
  },
};

// keyframes for loader (inject into global CSS)
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `@keyframes spin { 
    0% { transform: rotate(0deg); } 
    100% { transform: rotate(360deg); } 
  }`,
  styleSheet.cssRules.length
);
styleSheet.insertRule(
  `@keyframes fadeIn { 
    from { opacity: 0; transform: scale(0.95); } 
    to { opacity: 1; transform: scale(1); } 
  }`,
  styleSheet.cssRules.length
);

export default IbPaymentScreen;
